export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9424.11cffe01.jpg";